const reducerName = '@cityoo-backoffice/territories/districts';

export const RESET = `${reducerName}/RESET`;

export const GET_DISTRICTS_START = `${reducerName}/GET_DISTRICTS_START`;
export const GET_DISTRICTS_SUCCESS = `${reducerName}/GET_DISTRICTS_SUCCESS`;
export const GET_DISTRICTS_FAIL = `${reducerName}/GET_DISTRICTS_FAIL`;
